<template>
  <v-row class="pt-3 px-6">
    <v-col cols="12" v-if="loading.getMenus && !menus.length">
      <v-row justify="center" align="center" style="min-height: 300px;">
        <v-col cols="auto">
          <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" v-else-if="!menus.length">
      <category-menu-select-date
        :selected-date="selectedDate"
        @subOneDay="subOneDay"
        @addOneDay="addOneDay"
      ></category-menu-select-date>
      <v-alert dense text type="warning" color="warning">
        {{ $t('no_menus_available_period') }}
      </v-alert>
      <template v-if="order && order.transaction && order.transaction.length">
        <div class="py-4 text-center ordera-toolbar border-light">
          {{ $t("pages.category_menu.sentence_4") }}
        </div>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            offset-sm="3"
            v-for="product in order.transaction"
            :key="product.id"
            class="py-1"
          >
            <v-sheet color="#fafafa" class="px-2 py-4" style="border-radius: 8px">
              <span class="food-box-name">
                {{ product.quantity ? product.quantity + "x " : "" }}{{ toLatin(product.food.name) }}
              </span>
            </v-sheet>
          </v-col>
        </v-row>
      </template>
    </v-col>
    <template v-else>
      <v-col cols="12" sm="3">
        <v-row v-if="selectedMenu">
          <category-menu-select-date
            v-if="!device.isDesktop"
            :selected-date="selectedDate"
            @subOneDay="subOneDay"
            @addOneDay="addOneDay"
          ></category-menu-select-date>
          <v-col cols="12">
            <div
              v-if="device.isDesktop"
              class="py-4 text-center ordera-toolbar border-light"
            >
              {{ $t("pages.category_menu.sentence_3") }}
            </div>
            <shift-box
              v-model="shift"
              :selectedMenu="selectedMenu"
              :shiftEnable="shiftEnable"
              :class="{
                'py-3': device.isDesktop,
                'pb-3': !device.isDesktop,
              }"
              :disabled="loading.saveOrder || loading.updateOrder"
            ></shift-box>
          </v-col>
          <v-col cols="12" v-if="shiftAsText && device.isDesktop">
            <v-row>
              <v-col
                v-for="(item, key) in Object.keys(selectedMenu[shiftAsText])"
                :key="item.id"
                cols="12"
                class="py-1"
              >
                <v-sheet
                  :color="category != item ? '#fafafa' : 'primary'"
                  :class="{
                    'black--text': category != item,
                    'white--text': category == item,
                    'px-2': true,
                    'py-4': true,
                    'rounded-8': true,
                  }"
                  @click="category = item"
                >
                  {{ translate(item) }}
                </v-sheet>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" align="center">
        <v-row>
          <category-menu-select-date
            v-if="device.isDesktop"
            :selected-date="selectedDate"
            @subOneDay="subOneDay"
            @addOneDay="addOneDay"
          ></category-menu-select-date>
          <v-col cols="12" v-if="category && shiftAsText">
            <template v-if="!device.isDesktop">
              <v-row
                v-for="(foodCategory, i) in Object.keys(selectedMenu[shiftAsText])"
                :key="i"
                class="mb-6"
              >
                <v-col cols="12">
                  <h2 class="mb-4 title">{{ foodCategory }}</h2>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="(item, j) in selectedMenu[shiftAsText][foodCategory]"
                      :key="j"
                    >
                      <category-menu-food-card
                        :item="item"
                        :is-selected="selectedFoods.some((i) => i.food.id == item.id)"
                        :disabled="checkDisabled || loading.saveOrder || loading.updateOrder"
                        :is-category-selected="isCategorySelected(foodCategory)"
                        @foodToggled="
                          selectedFoods.some((i) => i.food.id == item.id)
                            ? deselectFood(item, true, foodCategory)
                            : selectFood(item, foodCategory)
                        "
                      ></category-menu-food-card>
                      <v-divider
                        v-if="j < selectedMenu[shiftAsText][foodCategory].length - 1"
                      ></v-divider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-col
                v-for="item in selectedMenu[shiftAsText][category]"
                :key="item.id"
                cols="12"
                class="pt-0 cursor-pointer"
                @click="!checkDisabled && !loading.saveOrder && !loading.updateOrder && selectFood(item)"
              >
                <category-menu-food-card
                  :item="item"
                  :is-selected="selectedFoods.some((i) => i.food.id == item.id)"
                  :disabled="checkDisabled || loading.saveOrder || loading.updateOrder"
                  :is-category-selected="isCategorySelected(category)"
                ></category-menu-food-card>
                <v-divider></v-divider>
              </v-col>
            </template>
          </v-col>
          <v-col cols="12" v-else>
            <v-alert dense text type="warning" color="primary">
              {{ $t("pages.category_menu.sentence_2") }}
            </v-alert>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="3">
        <v-row v-if="selectedMenu">
          <template v-if="device.isDesktop">
            <v-col cols="12">
              <div class="py-4 text-center ordera-toolbar border-light">
                {{ $t("pages.category_menu.sentence_4") }}
              </div>
              <shift-box
                v-model="shift"
                :selectedMenu="selectedMenu"
                :shiftEnable="shiftEnable"
                class="py-3"
                :disabled="loading.saveOrder || loading.updateOrder"
              ></shift-box>
            </v-col>
            <category-menu-card
              v-for="(item, i) in selectedFoods.filter((i) => i.shift === shiftAsText)"
              :key="item.id"
              :item="item"
              :check-disabled="checkDisabled"
              @deselect-food="deselectFood(item)"
            ></category-menu-card>
          </template>
          <v-col cols="12">
            <primary-button
              block
              @click="!checkDisabled ? (disable ? update() : saveOrder()) : null"
              v-if="
                disable ||
                !(
                  checkDisabled ||
                  !selectedFoods.some(
                    (i) => i.shift === shiftAsText && i.food.name !== 'empty'
                  )
                )
              "
              height="46"
              :loading="loading.saveOrder || loading.updateOrder"
              :disabled="loading.saveOrder || loading.updateOrder || checkDisabled"
            >
              <v-icon class="mr-2">mdi-cart-outline</v-icon>
              {{
                disable
                  ? $t("pages.category_menu.sentence_8")
                  : $t("pages.category_menu.sentence_7")
              }}
            </primary-button>
          </v-col>
        </v-row>
      </v-col>
    </template>

    <category-menu-overlay v-model="dialog" :log="log" :timeleft="timeleft">
    </category-menu-overlay>
  </v-row>
</template>

<script>
import moment from "moment";
import ShiftBox from "@/components/categoryMenu/shiftBox";
import conf from "@/config.json";
import CategoryMenuFoodCard from "@/components/categoryMenu/CategoryMenuFoodCard.vue";
import CategoryMenuCard from "@/components/categoryMenu/CategoryMenuCard.vue";
import CategoryMenuOverlay from "@/components/categoryMenu/CategoryMenuOverlay.vue";
import CategoryMenuSelectDate from "@/components/categoryMenu/CategoryMenuSelectDate.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import menuService from "@/services/menu";
import restaurantService from "@/services/restaurant";
import orderService from "@/services/order";

export default {
  mixins: [hasSnackbar],
  components: {
    ShiftBox,
    CategoryMenuFoodCard,
    CategoryMenuOverlay,
    CategoryMenuCard,
    CategoryMenuSelectDate,
  },
  data() {
    return {
      conf,
      selectedDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menus: [],
      category: null,
      selectedFoods: [],
      shift: null,
      dialog: false,
      shiftEnable: "all",
      disable: false,
      restaurantOrderTime: null,
      order: null,
      timeleft: 2,
      log: null,
      loading: {
        getRestaurantTimes: false,
        getMenus: false,
        getOrders: false,
        saveOrder: false,
        updateOrder: false,
      },
    };
  },
  async created() {
    if (this.loading.getRestaurantTimes) {
      console.warn("Get restaurant times operation already in progress");
      return;
    }

    this.loading.getRestaurantTimes = true;

    try {
      const res = await restaurantService.getRestaurantNewTimes(this.company.restaurant_id);
      this.restaurantOrderTime = res.data.data;
    } catch (error) {
      console.error("Error fetching restaurant times:", error);
    } finally {
      this.loading.getRestaurantTimes = false;
    }
  },
  methods: {
    isCategorySelected(category) {
      return this.selectedFoods.some((i) =>
        this.selectedMenu[this.shiftAsText][category].some((j) => i.food.id == j.id)
      );
    },
    // Navigation between days
    subOneDay() {
      this.disable = false;
      this.selectedDate = moment(this.selectedDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.getMenus();
    },
    addOneDay() {
      this.disable = false;
      this.selectedDate = moment(this.selectedDate).add(1, "days").format("YYYY-MM-DD");
      this.getMenus();
    },

    // Fetch menus and orders
    async getMenus() {
      if (this.loading.getMenus) {
        console.warn("Get menus operation already in progress, skipping duplicate request");
        return;
      }

      const fromDate = this.selectedDate;

      this.loading.getMenus = true;
      this.loading.getOrders = true;
      this.menus = [];

      const params = {
        from: fromDate,
        to: fromDate,
        type: "rucak",
      };

      try {
        const menusRes = await menuService.getWebAppMenu(params);
        this.menus = menusRes.data;

        try {
          const ordersRes = await orderService.getOrdersByDate(this.selectedDate);
          this.order = null;
          if (ordersRes.data) {
            this.order = ordersRes.data[0];
            this.populateSelectedFoodsFromOrder(this.order);
          }
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          this.loading.getOrders = false;
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        this.loading.getMenus = false;
      }
    },

    // Fill selectedFoods with empty food objects for each category/shift
    initSelectedFoods() {
      this.selectedFoods = [];
      if (!this.selectedMenu) return;
      ["shiftOne", "shiftTwo", "shiftThree", "shiftFour"].forEach((shift) => {
        if (this.selectedMenu[shift]) {
          Object.keys(this.selectedMenu[shift]).forEach((category) => {
            this.selectedFoods.push({
              food: { name: "empty" },
              category,
              shift,
            });
          });
        }
      });
    },

    // Fill selectedFoods with foods from an existing order
    populateSelectedFoodsFromOrder(order) {
      if (!order) return;
      let shift = null;
      if (order.shift === 1) {
        shift = "shiftOne";
        this.shiftEnable = "shiftOne";
        this.shift = 0;
      } else if (order.shift === 2) {
        shift = "shiftTwo";
        this.shiftEnable = "shiftTwo";
        this.shift = 1;
      } else if (order.shift === 3) {
        shift = "shiftThree";
        this.shiftEnable = "shiftThree";
        this.shift = 2;
      } else if (order.shift === 4) {
        shift = "shiftFour";
        this.shiftEnable = "shiftFour";
        this.shift = 3;
      }
      order.transaction.forEach((product) => {
        const item = this.selectedFoods.find(
          (i) => i.shift === shift && i.category === product.food.category.name
        );
        if (item) {
          item.food = product.food;
          this.disable = true;
        }
      });
    },

    // Add or remove food from selectedFoods
    selectFood(food, foodCategory) {
      const index = this.selectedFoods.findIndex(
        (i) =>
          i.category === (foodCategory || this.category) && i.shift === this.shiftAsText
      );
      this.shiftEnable = this.shiftAsText;
      this.selectedFoods[index].food = food;
    },

    deselectFood(item, isFood = false, foodCategory) {
      if (isFood) {
        const index = this.selectedFoods.findIndex(
          (i) =>
            i.category === (foodCategory || this.category) && i.shift === this.shiftAsText
        );
        this.selectedFoods[index].food = { name: "empty" };
        this.shiftEnable = this.selectedFoods.some(
          (i) => i.shift === this.shiftAsText && i.food.name !== "empty"
        )
          ? this.shiftAsText
          : "all";
      } else {
        item.food = { name: "empty" };
        this.shiftEnable = this.selectedFoods.some(
          (i) => i.shift === this.shiftAsText && i.food.name !== "empty"
        )
          ? this.shiftAsText
          : "all";
      }
    },

    // Save or update order
    async saveOrder() {
      if (this.loading.saveOrder) {
        console.warn("Save order operation already in progress, skipping duplicate request");
        return;
      }

      this.loading.saveOrder = true;

      const foods = this.selectedFoods.filter((i) => i.food.name !== "empty");
      const data = {
        foods,
        shift: this.shift + 1,
        restaurant_id: this.company.restaurant_id,
        company_id: this.company.pivot ? this.company.pivot.company_id : 0,
        date: this.selectedDate,
        app_type: 1,
      };
      this.log = null;

      try {
        const res = await orderService.storeFoodOrder(data);
        this.order = res.data.order;
        this.log = res.data.foods;
        this.disable = true;
        this.dialog = true;
        this.timeleft = 2;
        let downloadTimer = setInterval(() => {
          if (this.timeleft <= 0) {
            clearInterval(downloadTimer);
            this.dialog = false;
          }
          this.timeleft -= 1;
        }, 1000);
      } catch (err) {
        console.error("Error saving order:", err);
        this.showErrorSnackbar(err?.response?.data?.response || "Došlo je do greške.");
      } finally {
        this.loading.saveOrder = false;
      }
    },
    async update() {
      if (this.loading.updateOrder) {
        console.warn("Update order operation already in progress, skipping duplicate request");
        return;
      }

      this.loading.updateOrder = true;

      const foods = this.selectedFoods.filter((i) => i.food.name !== "empty");
      const data = {
        foods,
        shift: this.shift + 1,
        restaurant_id: this.company.restaurant_id,
        company_id: this.company.pivot ? this.company.pivot.company_id : 0,
        date: this.selectedDate,
        app_type: 1,
      };

      try {
        await orderService.updateFoodOrder(this.order.id, data);
        this.dialog = true;
        if (!(data.foods || []).length) this.disable = false;
        this.timeleft = 2;
        let downloadTimer = setInterval(() => {
          if (this.timeleft <= 0) {
            clearInterval(downloadTimer);
            this.dialog = false;
          }
          this.timeleft -= 1;
        }, 1000);
      } catch (err) {
        console.error("Error updating order:", err);
        this.showErrorSnackbar(err?.response?.data?.response || "Došlo je do greške.");
      } finally {
        this.loading.updateOrder = false;
      }
    },
    isOrderingDisabled(selectedDate) {
      if (!!this.user.no_time_limit_user) {
        return moment(selectedDate).isBefore(moment(), "day");
      }
      // If restaurant order time config is missing, allow ordering
      if (!this.restaurantOrderTime) return false;

      const currentDay = moment().format("dddd").toLowerCase();
      const dayConfig = this.restaurantOrderTime[currentDay];

      // If config for the current day or its time is missing, allow ordering
      if (!dayConfig || !dayConfig.time) return false;

      // Deadline for ordering for the selected date
      const orderDeadline = moment(selectedDate)
        .set("hour", dayConfig.time.time_hour)
        .set("minutes", dayConfig.time.time_minut);

      // Determine which limit to use based on current time
      const limitDays = moment().isBefore(orderDeadline)
        ? dayConfig.day_before_limit
        : dayConfig.day_after_limit;

      // Calculate the last moment when ordering is allowed
      const lastAllowedMoment = moment().add(limitDays, "days");
      const compareMoment = moment(selectedDate).add(1, "days");

      // If the last allowed moment is before or same as the selected date, disable ordering
      return lastAllowedMoment.diff(compareMoment) >= 0;
    },
  },
  computed: {
    minOrderDate() {
      if (this.$store.state.user.orderRules.ignoreTimelimit)
        return moment().format("YYYY-MM-DD");
      const dayName = new Date()
        .toLocaleDateString("en-US", {
          weekday: "long",
        })
        .toLowerCase();
      if (!this.restaurantOrderTime || !this.restaurantOrderTime[dayName]) {
        return null;
      }

      const todayRules = this.restaurantOrderTime[dayName];
      if (!todayRules) return this.menus;
      // Get the current date components
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const day = now.getDate();

      const customHours = todayRules.time.time_hour;
      const customMinutes = todayRules.time.time_minut;

      const customDate = new Date(year, month, day, customHours, customMinutes, 0, 0);
      const isExpired = now.getTime() - customDate.getTime() > 0;
      const daysToAdd = isExpired
        ? todayRules.day_after_limit
        : todayRules.day_before_limit;
      let nextMenuDateObj = new Date(now.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
      return nextMenuDateObj.toISOString().slice(0, 10);
    },
    company() {
      return this.$store.state.company;
    },
    selectedMenu() {
      return this.menus.find((menu) => menu.date === this.selectedDate);
    },
    shiftAsText() {
      if (!this.selectedMenu) return;
      const shifts = [];
      if (this.selectedMenu.shiftOne) shifts.push("shiftOne");
      if (this.selectedMenu.shiftTwo) shifts.push("shiftTwo");
      if (this.selectedMenu.shiftThree) shifts.push("shiftThree");
      if (this.selectedMenu.shiftFour) shifts.push("shiftFour");
      return shifts[this.shift];
    },
    checkDisabled() {
      return this.isOrderingDisabled(this.selectedDate);
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  watch: {
    minOrderDate: {
      handler(newDate) {
        if (newDate) {
          this.selectedDate = newDate;
          this.getMenus();
        }
      },
      immediate: true,
    },
    shiftAsText() {
      if (!this.selectedMenu) return;
      this.category = Object.keys(this.selectedMenu[this.shiftAsText])[0];
    },
    selectedMenu(menu) {
      if (menu) {
        if (menu.shiftOne && this.shift === null) this.shift = 0;
        if (menu.shiftTwo && this.shift === null) this.shift = 1;
        if (menu.shiftThree && this.shift === null) this.shift = 2;
        if (menu.shiftFour && this.shift === null) this.shift = 3;
        this.initSelectedFoods();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.border-light {
  border: 1px solid #0000001a;
}

.rounded-8 {
  border-radius: 8px;
}
.cursor-pointer {
  cursor: pointer;
}

.ordera-toolbar {
  background-color: rgba($primary-color, 0.05);
  border-radius: 8px 8px 0 0;
}

.btn-order {
  position: sticky;
  text-transform: none;
}
.btn-order--mobile {
  position: fixed;
  bottom: 4px;
  left: 4px;
  width: calc(100% - 8px);
  z-index: 10;
}
</style>
